import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminLocationContent from "@/pages/admin/AdminLocationContent";

export const Route = createFileRoute("/admin/location-content")({
  head: () => pageHead("Admin \u2014 Location Content \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminLocationContent,
});
